import { connect } from 'react-redux';
import { mapValueFromConfig, mapButtonsFromConfig } from '../../../../helpers/my-plan';
import { getStatusPlain } from '../../../../helpers/custom-page/is-completed';
import { Widget } from './component';

export const MyPlanContainer = connect(({ statusData }, { title, subtitle, data }) => {
  const { buttons, labels } = data;
  const { parsedStatuses } = statusData;

  const status = getStatusPlain(parsedStatuses.myPlan);

  return {
    title: mapValueFromConfig(title, status),
    subtitle: mapValueFromConfig(subtitle, status),
    buttons: mapButtonsFromConfig(buttons, status),
    labels
  };
});

export const MyPlan = MyPlanContainer(Widget);
